import { ArrowDownIcon } from '@gto/icons-react/solid/arrow-down'
import { ArrowUpIcon } from '@gto/icons-react/solid/arrow-up'
import { ChevronUpDownIcon } from '@gto/icons-react/solid/chevron-up-down'
import { cn } from '@gto/ui/cn'

import type { SortDirection } from './aria-sort'

export type SortIndicatorProps = {
  sort: SortDirection
  className?: string
}

// Shared geometry + fade/recolour curve for the sort glyphs (matches the MUI reference).
const SORT_INDICATOR_BASE = 'size-4 shrink-0 transition-[opacity,color] duration-300 ease-out'

/**
 * Column-header sort indicator. Solid green up/down arrow when sorted (always visible);
 * unsorted shows a neutral double-chevron hidden at rest that fades in on hover — the
 * reveal is driven by the header cell's `group/header` class, so this stays a presentational
 * leaf with no hover state of its own. `aria-hidden` keeps the decorative glyph out of the
 * header's accessible name (the a11y sort channel is `aria-sort`).
 */
export const SortIndicator = ({ sort, className }: SortIndicatorProps) => {
  if (sort === 'asc') {
    return (
      <ArrowUpIcon
        aria-hidden
        className={cn(SORT_INDICATOR_BASE, 'text-primary-main opacity-100', className)}
      />
    )
  }
  if (sort === 'desc') {
    return (
      <ArrowDownIcon
        aria-hidden
        className={cn(SORT_INDICATOR_BASE, 'text-primary-main opacity-100', className)}
      />
    )
  }

  return (
    <ChevronUpDownIcon
      aria-hidden
      className={cn(
        SORT_INDICATOR_BASE,
        'text-text-secondary opacity-0 group-hover/header:opacity-100',
        className,
      )}
    />
  )
}
